/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SuppliersSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: SuppliersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';

import { SuppliersData, SuppliersService }  from './Suppliers.service';


@Component({
  selector: 'SuppliersSearch',
  template: require('./SuppliersSearch.component.html'),
  providers: [SuppliersService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(100%)'
        }),
        animate('0.9s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class SuppliersSearchComponent implements OnInit {
	@Output() filterCriteria = new EventEmitter<string>();
	
	/* Animation for Search section */
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objSuppliers: SuppliersData;
	errorMessage: string;
	messages: string[];
	filterExpression: string;
	showSearch: boolean;

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private SuppliersService: SuppliersService

	) {
		// this.id = parseInt(params.get('id'));
		this.objSuppliers = new SuppliersData();
		/* Initialize Lookup field values
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.filterCriteria = new EventEmitter<string>();
	}

	ngOnInit() {
		// Getting lookup data
		this.getLookups();
	}
	
	clearCriteria() {
		/* To empty values in textbox and dropdown lists
		this.objProducts.ProductName = '';
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.objSuppliers = new SuppliersData();
		this.filterExpression = '';
		event.preventDefault();
		console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}
	
	onExpandCollapse()
	{
		this.showSearch = !this.showSearch;
	}
	
	searchProducts() {
		// Updating filterExpression on Search button click
		this.filterExpression = '';
		
		if (this.objSuppliers.SupplierID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objSuppliers.SupplierID;
			else
				this.filterExpression = "SupplierID = " + this.objSuppliers.SupplierID;
		}
		if (this.objSuppliers.CompanyName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CompanyName like '%" + this.objSuppliers.CompanyName + "%'";
			else
				this.filterExpression = "CompanyName like '%" + this.objSuppliers.CompanyName + "%'";
		}
		if (this.objSuppliers.ContactName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ContactName like '%" + this.objSuppliers.ContactName + "%'";
			else
				this.filterExpression = "ContactName like '%" + this.objSuppliers.ContactName + "%'";
		}
		if (this.objSuppliers.ContactTitle)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ContactTitle like '%" + this.objSuppliers.ContactTitle + "%'";
			else
				this.filterExpression = "ContactTitle like '%" + this.objSuppliers.ContactTitle + "%'";
		}
		if (this.objSuppliers.Address)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Address like '%" + this.objSuppliers.Address + "%'";
			else
				this.filterExpression = "Address like '%" + this.objSuppliers.Address + "%'";
		}
		if (this.objSuppliers.City)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND City like '%" + this.objSuppliers.City + "%'";
			else
				this.filterExpression = "City like '%" + this.objSuppliers.City + "%'";
		}
		if (this.objSuppliers.Region)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Region like '%" + this.objSuppliers.Region + "%'";
			else
				this.filterExpression = "Region like '%" + this.objSuppliers.Region + "%'";
		}
		if (this.objSuppliers.PostalCode)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND PostalCode like '%" + this.objSuppliers.PostalCode + "%'";
			else
				this.filterExpression = "PostalCode like '%" + this.objSuppliers.PostalCode + "%'";
		}
		if (this.objSuppliers.Country)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Country like '%" + this.objSuppliers.Country + "%'";
			else
				this.filterExpression = "Country like '%" + this.objSuppliers.Country + "%'";
		}
		if (this.objSuppliers.Phone)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Phone like '%" + this.objSuppliers.Phone + "%'";
			else
				this.filterExpression = "Phone like '%" + this.objSuppliers.Phone + "%'";
		}
		if (this.objSuppliers.Fax)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Fax like '%" + this.objSuppliers.Fax + "%'";
			else
				this.filterExpression = "Fax like '%" + this.objSuppliers.Fax + "%'";
		}
		if (this.objSuppliers.HomePage)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND HomePage like '%" + this.objSuppliers.HomePage + "%'";
			else
				this.filterExpression = "HomePage like '%" + this.objSuppliers.HomePage + "%'";
		}

		
		/* Build Search here
		if (this.objProducts.ProductName)
		{
			this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
		}
		if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
			else
				this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
		}
		if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
			else
				this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
		}
		*/
		event.preventDefault();
    	console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}



	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Suppliers/SuppliersSearch.component.ts